module.exports = __webpack_public_path__ + "img/avatar_agent_man.29b22f20.jpg";